module.exports = __webpack_public_path__ + "img/doc-ad1-xs.11e1bec5.jpg";